import React from 'react';

function MoveLeft({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M20 16H8" />
      <path d="M24 7L24 25" />
      <path d="M13 21L8 16L13 11" />
    </svg>
  );
}

export default MoveLeft;
